// extracted by mini-css-extract-plugin
export default {"faq":"faq_faq__uckSw"};